import * as yup from 'yup';

export const operationsAndInfoSchema = yup.object().shape({
	facilityName: yup.string().required('Facility Name is required'),
	siteAddress: yup.string().required('Site address is required'),
	siteArea: yup.string().required('Site City/Are is required'),
	address: yup.string().required('Mailing address is required'),
	city: yup.string().required('City is required'),
	state: yup.string().required('State is required'),
	zip: yup
		.string()
		.required('Zip is required')
		.matches(/[0-9]{5}/g, 'Invalid zip'),
	facilityPerson: yup.string().required('Name is required'),
	title: yup.string().required('Title is required'),
	// prettier-ignore
	businessActivity: yup.string().required('Principle Business Activity is required'),
	numEmployees: yup.string().required('Number of Employees is required'),
	numShifts: yup.string().required('Number of Shifts is required'),
	hrsOperation: yup.object().shape({
		open: yup.string().when('additionalHours', {
			is: value => !value,
			then: schema => schema.required('Opening time is required.'),
		}),
		close: yup.string().when('additionalHours', {
			is: value => !value,
			then: schema => schema.required('Closing time is required.'),
		}),
		additionalHours: yup.string(),
	}),
});
